export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14513.617e81c4.jpg";